export const adminMenuItems: any[] = [
  {
    displayText: 'Dashboard',
    icon: 'dashboard',
    routerLink: '/dashboard',
  },
  {
    displayText: 'Properties',
    icon: 'home_work',
    subMenus: [
      {
        displayText: 'Post Properties',
        icon: 'post_add',
        routerLink: '/property/rent/manage',
      },
      {
        displayText: 'Owner Properties',
        icon: 'person_outline',
        routerLink: '/property/rent/owner-properties',
      },
    ],
  },
  {
    displayText: 'New Projects',
    icon: 'domain_add',
    subMenus: [
      {
        displayText: 'All Projects',
        icon: 'apartment',
        routerLink: '/new-projects/all',
      },
      {
        displayText: 'Builders',
        icon: 'construction',
        routerLink: '/new-projects/builders',
      },
    ],
  },
  {
    displayText: 'Leads Setup',
    icon: 'groups',
    subMenus: [
      {
        displayText: 'Tenant Leads',
        icon: 'table_view',
        routerLink: '/leads/tenants',
      },
      {
        displayText: 'Owner Leads',
        icon: 'table_view',
        routerLink: '/leads/owners',
      },
    ],
  },
  {
    displayText: 'Users',
    icon: 'manage_accounts',
    subMenus: [
      {
        displayText: 'All Users',
        icon: 'table_view',
        routerLink: '/users/all',
      },
    ],
  },
  {
    displayText: 'Campaign',
    icon: 'campaign',
    subMenus: [
      {
        displayText: 'Email Campaigns',
        icon: 'alternate_email',
        routerLink: '/campaigns',
      },
    ],
  },
  {
    displayText: 'Profile',
    icon: 'account_circle',
    subMenus: [
      {
        displayText: 'My Profile',
        icon: 'badge',
        routerLink: '/profile',
      },
    ],
  },
  {
    displayText: 'Cities',
    icon: 'location_city',
    subMenus: [
      {
        displayText: 'All Cities',
        icon: 'apartment',
        routerLink: '/cities/all',
      },
    ],
  },
  {
    displayText: 'Request Call Back',
    icon: 'support_agent',
    subMenus: [
      {
        displayText: 'Owner Req Callback',
        icon: 'call',
        routerLink: '/users/owner-call-requests',
      },
      {
        displayText: 'Tenant Req Callback',
        icon: 'call',
        routerLink: '/users/contact-us-requests',
      },
    ],
  },
];
